import '@zr/common/js/jquery-plugins/zr.errorTrapper';

/**
 * Note: This will eventually be migrated to web/common/frontend. Avoid adding any app-specific code here.
 */
function initEvents() {
  window.zr.event = window.zr.event || {};
  window.zr.event.allFired = window.zr.event.allFired || '';
  window.zr.event.originType = 'jobs'; // TODO: Parameterize.

  if (window.zr.event.DisablePageViewLog) {
    return;
  }

  window.zr.event.hasApplyUrl = window.zr.page.model.hasApplyUrl;

  // Log the page_view event.
  window.zr.event.logPageView();

  // Log JS errors to mixpanel.
  window.zr.errorTrapper.startLogger('asEvent');
}

// This may be loading AFTER DOMContentLoaded !
if (document.readyState !== 'loading') {
  initEvents();
} else {
  document.addEventListener('DOMContentLoaded', initEvents);
}


// TODO: Evaluate whether this commented-out code below has the same functionality as zr.errorTrapper or can be adapted easily.
/**
 * Logs js_error events.
 */
// function errorEvent(err, url, line, column, oerror) {
//   // Only log one error per page view.
//   if (window.zr && window.zr.event && window.zr.event.loggedError) {
//     return;
//   }

//   window.zr.event.loggedError = true;
//   const el = window.zr.page.model.eventLogging;

//   if (el.LogJavascriptErrors === 'asEvent') {
//     if ($.log_event) {
//       const serr = typeof err === 'object' ? err.toString() : err;
//       const sline = typeof line === 'object' ? line.toString() : line;
//       const scolumn = typeof column === 'object' ? column.toString() : column;
//       const surl =  typeof url === 'object' ? url.toString() : url;

//       $.log_event('js_error', {
//         errorDescription: serr,
//         errorLine: sline,
//         errorColumn: scolumn,
//         errorUrl: surl,
//         errorStack: oerror.stack,
//         non_interaction: 1,
//       });
//     }
//   }
// }
